module.exports = __webpack_public_path__ + "img/publish.678575f.png";